import { FieldType, DefaultFormTableSchema } from "./types";
import { propertyMessage } from "@ploy-lib/types";
export class PropertiesSchema extends DefaultFormTableSchema {
    constructor() {
        super({
            tableData: {
                isDeletableRow(rowData, cells) {
                    return Boolean(rowData.addedManually);
                },
                rowSorter(row1, row2) {
                    const pri1 = row1.priority || 0;
                    const pri2 = row2.priority || 0;
                    if (pri1 < pri2)
                        return -1;
                    else if (pri1 > pri2)
                        return 1;
                    return 0;
                }
            },
            columnData: {
                refinance: {
                    fieldType: FieldType.Checkbox,
                    alwaysInEditMode: true
                },
                propertyInformation: {
                    fieldType: FieldType.Text,
                    isMultiline: true
                },
                streetName: {
                    fieldType: FieldType.Text,
                    displayValue: (_, rowData) => {
                        return `${rowData.streetName} ${rowData.addressNumber || ""}${rowData.addressLetter || ""}, ${padPostalCode(rowData.postalCode) || ""}, ${rowData.postalPlace || ""}`;
                    }
                },
                cadastralNumber: {
                    fieldType: FieldType.Text,
                    isRequired: true
                },
                municipalityNumber: {
                    fieldType: FieldType.Text
                },
                cadastralUnitNumber: {
                    fieldType: FieldType.Text
                },
                unitNumber: {
                    fieldType: FieldType.Text
                },
                leaseholdUnitNumber: {
                    fieldType: FieldType.Text
                },
                priority: {
                    fieldType: FieldType.Number
                },
                jointDebt: {
                    fieldType: FieldType.Currency,
                    displayValue: (value, rowData) => {
                        const propertyType = rowData["type"];
                        return propertyType === "Share" || propertyType === "Stock"
                            ? value
                            : "-";
                    },
                    isEditableFunctions: {
                        HasValidType: (form, columnCells) => {
                            const propertyType = form.values["type"];
                            return propertyType === "Share" || propertyType === "Stock";
                        }
                    }
                },
                valueEnteredByCustomer: {
                    fieldType: FieldType.Currency
                },
                estimatedValue: {
                    fieldType: FieldType.Currency
                },
                utilizedValue: {
                    fieldType: FieldType.Currency
                },
                utilizedSecurityValue: {
                    fieldType: FieldType.Currency
                },
                owners: {
                    fieldType: FieldType.Multiselect
                },
                eAppraisalReference: {
                    fieldType: FieldType.Text
                },
                eAppraisalDate: {
                    fieldType: FieldType.Date
                },
                type: {
                    fieldType: FieldType.Select,
                    displayValueIntlDescriptor(value) {
                        return propertyMessage[value];
                    },
                    isRequired: true
                },
                deleteCadastral: {
                    fieldType: FieldType.Checkbox
                }
            }
        });
    }
}
const padPostalCode = (postalCode) => postalCode?.padStart(4, "0");
//# sourceMappingURL=PropertiesSchema.js.map